import React, { useEffect, useState } from 'react';
import moment from 'moment';
import DeleteModal from '../../utils/deleteModal/deleteModal';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import AddUser from './AddUser';
import services from '../../services';
import { GET_ALL_USER } from '../../utils/Apifunction';
import { FiEdit } from 'react-icons/fi';
import { MdDeleteOutline, MdAdd, MdChevronLeft, MdChevronRight } from 'react-icons/md';
import Select from "react-select";
import './User.css';
import { FaLocationDot } from "react-icons/fa6";

const userTypeOptions = [
    { value: "Driver", label: "Driver" },
    { value: "Tour Guide", label: "Tour Guide" },
    { value: "Accommodation", label: "Accommodation" },
    { value: "Restaurant", label: "Restaurant" },
    { value: "Flight", label: "Flight" },
    { value: "Transportation", label: "Transportation" },
    { value: "Attraction Ticket", label: "Attraction Ticket" },
    { value: "Rent-a-Car", label: "Rental" },
    { value: "Ferry", label: "Ferry" },
    { value: "Manager", label: "Manager" },
    { value: "Product Manager", label: "Product Manager" },
    { value: "Sales", label: "Sales" },
    { value: "Logistic Manager", label: "Logistic Manager" },
    { value: "Operations Manager", label: "Operations Manager" },
    { value: "Travel Agent", label: "Travel Agent" },
    { value: "Reservation Team", label: "Reservation Team" },
];
const UserTable = () => {
    const [userData, setUserData] = useState([]);
    const [editData, setEditData] = useState('');
    const [editId, setEditId] = useState('');
    const [showModalDelete, setShowModalDelete] = useState(false);
    const [selectDeleteId, setSelectDeleteId] = useState('');
    const [addUserStatus, setAddUserStatus] = useState(false);
    const [searchUserData, setSearchUserData] = useState('');
    const [sortProducts, setSortProducts] = useState({ key: 'createdAt', direction: 'desc' });
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const pageSize = 20;
    const [gmailUsers, setGmailUsers] = useState([]);
    const [selectedEmails, setSelectedEmails] = useState([]);
    const navigate = useNavigate();
    const [countryList, setCountryList] = useState([]);
    const [stateList, setStateList] = useState([]);
    const [cityList, setCityList] = useState([]);
    const [locationFilter, setLocationFilter] = useState({
        country: '',
        state: '',
        city: ''
    });
    const [filterUserType, setFilterUserType] = useState("");
    const [userGroup, setUserGroup] = useState("");
    const [appliedFilters, setAppliedFilters] = useState({
        country: '',
        state: '',
        city: '',
        userType: '',
        search: '',
        group: ''
    });
    const [loader, setloader] = useState(false);
    const [groupValues, setGroupValues] = useState([]);
    const handleStatusToggle = async (item) => {
        try {
            await services.user.UPDATE_USER(item?.id, { status: !item?.status });
            toast.success(`${item?.name}'s status updated successfully!`);
            GET_ALL_USER_DATA();
        } catch (e) {
            toast.error('Failed to update status!');
            console.error(e);
        }
    };

    const handleEdit = (data) => {
        setEditData(data);
        setAddUserStatus(true);
        setEditId(data?.id);
    };

    const handleDelete = async () => {
        try {
            await services.user.DELETE_USER(selectDeleteId);
            toast.success('User deleted successfully!');
            GET_ALL_USER_DATA();
        } catch (e) {
            toast.error('Failed to delete user!');
            console.error(e);
        }
    };
    const getAllLinkedEmail = async () => {
        try {
            const response = await services.email.Get_The_Linked_Email();
            if (response) {
                const options = response?.data?.map((email) => ({
                    label: email.email,
                    value: email.id,
                    color: email.colour,
                }));
                setGmailUsers(options);
            }
        } catch (error) {
            console.error('error');
        }
    };
    const handleConfirm = () => {
        setShowModalDelete(false);
        handleDelete();
    };

    useEffect(() => {
        GET_ALL_USER_DATA();

    }, [appliedFilters, sortProducts, currentPage]);
    useEffect(() => {
        getAllLinkedEmail()

    }, [])
    const GET_ALL_USER_DATA = async () => {
        setloader(true)
        const object = {
            page: currentPage,
            search: appliedFilters.search,
            sortBy: sortProducts.key,
            sortOrder: sortProducts.direction,
            limit: pageSize,
            isPermission: true,
            country: appliedFilters.country,
            state: appliedFilters.state,
            city: appliedFilters.city,
            userType: appliedFilters.userType,
            groupId: appliedFilters.group
        };
        try {
            const response = await GET_ALL_USER(object);
            if (response) {
                setUserData(response?.users || []);
                setTotalPages(response?.totalPages || 1);
            }
        } catch (error) {
            console.log(error)
        } finally {
            setloader(false)
        }

    };

    function handleSort(key) {
        setSortProducts((prev) => {
            if (prev.key === key) {
                return { key, direction: prev.direction === 'asc' ? 'desc' : 'asc' };
            }
            return { key, direction: 'asc' };
        });
        setCurrentPage(1);
    }
    function renderSortIcon(key) {
        if (sortProducts.key !== key) return null;
        return sortProducts.direction === 'asc' ? ' ▲' : ' ▼';
    }
    const [selectedEmailsByUser, setSelectedEmailsByUser] = useState({});
    const handleArchivePermission = async (item) => {
        try {
            await services.user.UPDATE_USER(item?.id, { isPermission: !item?.isPermission });
            toast.success(`${item?.name}'s archive permission updated successfully!`);
            GET_ALL_USER_DATA();
        } catch (e) {
            toast.error('Failed to update archive permission!');
            console.error(e);
        }
    };

    const handleAssingUser = async (userId, selectedEmails) => {
        try {
            await services.user.UPDATE_USER(userId, {
                usersEmailMapped: selectedEmails ?? []
            });

            toast.success(`Archive permissions updated successfully!`);
            GET_ALL_USER_DATA();
        } catch (e) {
            toast.error('Failed to update archive permission!');
            console.error(e);
        }
    };
    const handleEmailChange = (userId, selected) => {
        setSelectedEmailsByUser(prev => ({
            ...prev,
            [userId]: selected || []
        }));

        handleAssingUser(userId, selected)
    };
    useEffect(() => {
        if (Array.isArray(userData)) {
            const mapped = {};
            userData.forEach(user => {
                mapped[user.id] = user.usersEmailMapped || [];
            });
            setSelectedEmailsByUser(mapped);
        }
    }, [userData]);

    const getCountryGoupList = async () => {
        try {
            const params = new URLSearchParams({
                falsePagination: true,
            }).toString();
            const response = await services.user.GET_ALL_INCLUSIONGROUP(
                "destinations",
                params
            );
            setCountryList(response?.data?.data);
        } catch (error) {
            console.error(error);
        }
    };

    const getGroup = async () => {
        try {
            const object = {
                falsePagination: true,
            };
            const data = new URLSearchParams(object);
            const response = await services.user.GET_GROUP(data);
            setGroupValues(response?.data?.data);
        } catch (error) {
            console.error("error", error);
        }
    };
    useEffect(() => {
        getCountryGoupList();
        getGroup()
    }, []);

    const fetchStateList = async (countryId) => {
        if (!countryId) {
            setStateList([]);
            return;
        }
        const params = new URLSearchParams({
            country: countryId,
            falsePagination: true,
        });
        try {
            const response = await services.user.GET_INCLUSION(
                "destinations",
                params
            );
            setStateList(response?.data?.data || []);
        } catch (err) {
            console.error(err);
        }
    };

    const fetchCityList = async (countryId, stateId) => {
        if (!countryId || !stateId) {
            setCityList([]);
            return;
        }
        const params = new URLSearchParams({
            country: countryId,
            state: stateId,
        });
        try {
            const response = await services.user.GET_CITY(params);
            setCityList(response?.data?.data || []);
        } catch (err) {
            console.error(err);
        }
    };

    const onLocationChange = (field, value) => {
        setLocationFilter(prev => {
            const updated = { ...prev, [field]: value };

            if (field === "country") {
                updated.state = "";
                updated.city = "";
                setCityList([]);
                fetchStateList(value);
            } else if (field === "state") {
                updated.city = "";
                fetchCityList(prev.country, value);
            }

            return updated;
        });
    };

    const handleApplyFilter = () => {
        setAppliedFilters({
            ...locationFilter,
            userType: filterUserType,
            search: searchUserData,
            group: userGroup
        });
        setCurrentPage(1);
    };

    const handleReset = () => {
        const initialLocation = { country: '', state: '', city: '' };
        setLocationFilter(initialLocation);
        setFilterUserType("");
        setSearchUserData("");
        setAppliedFilters({
            ...initialLocation,
            userType: '',
            search: '',
            group: ''
        });
        setUserGroup("");
        setCurrentPage(1);
    };
    return (
        <div className="px-5 py-2 mb-3">

            <div className="container-fluid py-3">

                {/* TOP BAR */}
                <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">

                    {/* LEFT: Back + Title */}
                    <div className="d-flex align-items-center gap-3">
                        <button
                            className="btn btn-outline-primary btn-sm"
                            onClick={() => navigate('/app')}
                        >
                            Back
                        </button>

                        <h4 className="m-0 fw-bold text-primary">
                            User Management
                        </h4>
                    </div>

                    {/* RIGHT: Search */}
                    <div className="d-flex gap-2 align-items-center">
                        <input
                            type="text"
                            placeholder="Search by name or email..."
                            value={searchUserData}
                            onChange={(e) => setSearchUserData(e.target.value)}
                            onKeyDown={(e) => e.key === 'Enter' && handleApplyFilter()}
                            className="form-control form-control-sm"
                            style={{ maxWidth: "250px" }}
                        />
                        <button
                            className="btn btn-primary btn-sm"
                            onClick={handleApplyFilter}
                        >
                            Search
                        </button>
                    </div>
                </div>

                {/* FILTER SECTION */}
                <div className="card mt-3 p-3 shadow-sm">
                    <div className="row g-3 align-items-end">

                        {/* LOCATION */}
                        <div className="col-md-4">
                            <label className="fw-bold small mb-1">
                                Location
                            </label>
                            <div className="d-flex gap-2">
                                <select
                                    className="form-select form-select-sm"
                                    value={locationFilter.country || ""}
                                    onChange={(e) => onLocationChange("country", e.target.value)}
                                >
                                    <option value="">All Countries</option>
                                    {countryList.map(({ title, id }) => (
                                        <option key={id} value={id}>{title}</option>
                                    ))}
                                </select>

                                <select
                                    className="form-select form-select-sm"
                                    value={locationFilter.state || ""}
                                    onChange={(e) => onLocationChange("state", e.target.value)}
                                >
                                    <option value="">All States</option>
                                    {stateList.map(({ title, id }) => (
                                        <option key={id} value={id}>{title}</option>
                                    ))}
                                </select>

                                <select
                                    className="form-select form-select-sm"
                                    value={locationFilter.city || ""}
                                    onChange={(e) => onLocationChange("city", e.target.value)}
                                >
                                    <option value="">All Cities</option>
                                    {cityList.map(({ name, id }) => (
                                        <option key={id} value={id}>{name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        {/* USER TYPE */}
                        <div className="col-md-2">
                            <label className="fw-bold small mb-1">User Type</label>
                            <select
                                className="form-select form-select-sm"
                                value={filterUserType || ""}
                                onChange={(e) => setFilterUserType(e.target.value)}
                            >
                                <option value="">All</option>
                                {userTypeOptions.map((type, index) => (
                                    <option key={index} value={type.value}>
                                        {type.label}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* USER GROUP */}
                        <div className="col-md-2">
                            <label className="fw-bold small mb-1">User Group</label>
                            <select
                                className="form-select form-select-sm"
                                value={userGroup || ""}
                                onChange={(e) => setUserGroup(e.target.value)}
                            >
                                <option value="">All</option>
                                {groupValues.map((type, index) => (
                                    <option key={index} value={type.id}>
                                        {type.name}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* ACTION BUTTONS */}
                        <div className="col-md-4 d-flex gap-2">
                            <button
                                className="btn btn-primary btn-sm px-4"
                                onClick={handleApplyFilter}
                            >
                                Filter
                            </button>

                            <button
                                className="btn btn-outline-secondary btn-sm px-4"
                                onClick={handleReset}
                            >
                                Reset
                            </button>
                        </div>

                    </div>
                </div>

            </div>
            <div className="overflow-y-auto max-h-[69vh] overflow-x-auto rounded-xl border border-gray-200 pb-4">
                <table className="min-w-full bg-white">
                    <thead>
                        <tr>
                            <th
                                className="sticky top-0 z-10 px-4 py-2 text-left font-semibold text-blue-600 bg-blue-50 cursor-pointer"
                                onClick={() => handleSort('no')}
                            >
                                No.
                            </th>
                            <th
                                className="sticky top-0 z-10 px-4 py-2 text-left font-semibold text-blue-600 bg-blue-50 cursor-pointer"
                                onClick={() => handleSort('name')}
                            >
                                User Name
                            </th>
                            <th
                                className="sticky top-0 z-10 px-4 py-2 text-left font-semibold text-blue-600 bg-blue-50 cursor-pointer"
                                onClick={() => handleSort('email')}
                            >
                                Email
                            </th>
                            <th
                                className="sticky top-0 z-10 px-4 py-2 text-left font-semibold text-blue-600 bg-blue-50 cursor-pointer"
                                onClick={() => handleSort('createdAt')}
                            >
                                Create Date
                            </th>

                            <th
                                className="sticky top-0 z-10 px-4 py-2 text-left font-semibold text-blue-600 bg-blue-50 cursor-pointer"
                                onClick={() => handleSort('userEmailMapped')}
                            >
                                Assign Email Inbox
                            </th>
                            <th className="sticky top-0 z-10 px-4 py-2 text-left font-semibold text-blue-600 bg-blue-50">Actions</th>
                            <th className="sticky top-0 z-10 px-4 py-2 text-left font-semibold text-blue-600 bg-blue-50">
                                Archive Permission
                            </th>
                        </tr>
                    </thead>
                    <tbody className="table-body">
                        {loader ?
                            <tr>
                                <td colSpan="7" className="text-center text-gray-400 py-8">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </td>
                            </tr>
                            :
                            userData.length === 0 ? (
                                <tr>
                                    <td colSpan="7" className="text-center text-gray-400 py-3">
                                        No users found.
                                    </td>
                                </tr>
                            ) : (
                                userData.map((item, index) => (

                                    <tr key={item.id} className="hover:bg-blue-50 transition">
                                        <td className="px-4 py-2">{(currentPage - 1) * pageSize + index + 1}</td>
                                        <td className="px-4 py-2">{item?.name}</td>
                                        <td className="px-4 py-2">{item?.email}</td>
                                        <td className="px-4 py-2">{moment(item?.createdAt).format('DD MMM YYYY')}</td>
                                        <td className='multi-select-box'>
                                            <Select
                                                isMulti
                                                options={gmailUsers}
                                                value={selectedEmailsByUser[item.id] || []}
                                                onChange={(val) => handleEmailChange(item.id, val)}
                                                placeholder="Select user"
                                                closeMenuOnSelect={true}
                                                hideSelectedOptions={false}
                                            />

                                        </td>
                                        <td className="px-4 py-3 flex gap-2">

                                            <button
                                                className="table-icon-remove"
                                                onClick={() => {
                                                    setShowModalDelete(true);
                                                    setSelectDeleteId(item.id);
                                                }}
                                            >
                                                <MdDeleteOutline fontSize={20} />
                                            </button>
                                            <button
                                                className="table-icon-add"
                                                onClick={() =>
                                                    navigate('/assignboard', {
                                                        state: item,
                                                    })
                                                }
                                            >
                                                <MdAdd fontSize={20} />
                                            </button>
                                        </td>
                                        <td className="px-4 py-2">
                                            <div className="form-check form-switch flex items-center">
                                                <input
                                                    className="form-check-input h-5 w-9 rounded-full border-gray-300 bg-gray-200 checked:bg-blue-500 focus:ring-blue-400"
                                                    type="checkbox"
                                                    checked={item.isPermission}
                                                    onChange={() => handleArchivePermission(item)}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            )}
                    </tbody>
                </table>
            </div>
            <div className="flex flex-col sm:flex-row justify-center items-center gap-4 mt-2 mb-4">
                <div className="flex items-center gap-2">
                    <button
                        className="rounded-full border border-blue-400 text-blue-500 bg-white w-10 h-10 flex items-center justify-center shadow-sm hover:bg-blue-50 disabled:opacity-50 disabled:cursor-not-allowed"
                        onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                        disabled={currentPage === 1}
                        aria-label="Previous Page"
                    >
                        <MdChevronLeft size={28} />
                    </button>
                    <span className="font-medium text-base">
                        Page {currentPage} of {totalPages}
                    </span>
                    <button
                        className="rounded-full border border-blue-400 text-blue-500 bg-white w-10 h-10 flex items-center justify-center shadow-sm hover:bg-blue-50 disabled:opacity-50 disabled:cursor-not-allowed"
                        onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                        disabled={currentPage === totalPages}
                        aria-label="Next Page"
                    >
                        <MdChevronRight size={28} />
                    </button>
                </div>
            </div>
            {showModalDelete && (
                <DeleteModal
                    handleCloseModal={() => setShowModalDelete(false)}
                    handleConfirm={handleConfirm}
                    showModal={showModalDelete}
                    confirmButtonName="Delete"
                />
            )}
            {addUserStatus && (
                <AddUser
                    showModal={addUserStatus}
                    handleClose={() => setAddUserStatus(false)}
                    editData={editData}
                    GET_ALL_USER={GET_ALL_USER_DATA}
                    editId={editId}
                />
            )}
        </div>
    );
};

export default UserTable;
